<template>
    <div>
        <div class="container-fluid">
            <h1 class="mt-2 mb-1">
                {{ mobileHome.title }}
            </h1>
        </div>
        <section id="carrousel" />
        <div class="container-fluid">
            <div class="row swiper-1row d-md-none my-2 my-md-4 text-center">
                <div class="col-12">
                    <div class="ob1-carrousel zone-menu-swiper-container">
                        <div class="swiper-wrapper">
                            <div
                                v-for="(zoneMenuItem, zoneMenuItemIndex) in mobileHome.zoneMenu.zoneMenuItem"
                                :key="zoneMenuItemIndex"
                                class="swiper-slide  d-flex justify-content-center"
                            >
                                <a
                                    :href="zoneMenuItem.link"
                                    :data-oevent-category="zoneMenuItem.tms.tagZone"
                                    :data-oevent-action="zoneMenuItem.tms.tagName"
                                    :data-oevent-label="zoneMenuItem.link"
                                    class="no-decoration"
                                >
                                    <div :class="'icon ' + zoneMenuItem.icon + ' font-size-48'" aria-hidden="true" />
                                    <ob1-liens
                                        class="text-dark"
                                        :text="zoneMenuItem.text"
                                        :href="zoneMenuItem.link"
                                        no-decoration
                                        is-mini
                                        with-arrow
                                        :data-oevent-category="zoneMenuItem.tms.tagZone"
                                        :data-oevent-action="zoneMenuItem.tms.tagName"
                                        :data-oevent-label="zoneMenuItem.link"
                                    />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!--/* Format Desktop */-->
            <div class="d-none d-md-block px-lg-3 my-2 my-md-4">
                <div v-for="y in numberOfRows(6)" :key="y" class="row text-center">
                    <div v-for="x in 6" :key="x" class="col-2 px-0 d-flex justify-content-center">
                        <a
                            v-if="mobileHome.zoneMenu.zoneMenuItem[index(x, y, 6)]"
                            :href="mobileHome.zoneMenu.zoneMenuItem[index(x, y, 6)].link"
                            :data-oevent-category="mobileHome.zoneMenu.zoneMenuItem[index(x, y, 6)].tms.tagZone"
                            :data-oevent-action="mobileHome.zoneMenu.zoneMenuItem[index(x, y, 6)].tms.tagName"
                            :data-oevent-label="mobileHome.zoneMenu.zoneMenuItem[index(x, y, 6)].link"
                            class="no-decoration"
                        >
                            <div
                                :class="'icon ' + mobileHome.zoneMenu.zoneMenuItem[index(x, y, 6)].icon + ' font-size-48'"
                                aria-hidden="true"
                            />
                            <ob1-liens
                                class="text-dark mb-1"
                                :text="mobileHome.zoneMenu.zoneMenuItem[index(x, y, 6)].text"
                                :href="mobileHome.zoneMenu.zoneMenuItem[index(x, y, 6)].link"
                                with-arrow
                                is-mini
                                :data-oevent-category="mobileHome.zoneMenu.zoneMenuItem[index(x, y, 6)].tms.tagZone"
                                :data-oevent-action="mobileHome.zoneMenu.zoneMenuItem[index(x, y, 6)].tms.tagName"
                                :data-oevent-label="mobileHome.zoneMenu.zoneMenuItem[index(x, y, 6)].link"
                            />
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <template v-if="mobileHome.zoneContracts.zoneContractsItem.length > 0">
            <zone-contracts-collapse
                :contracts-with-collapse="contractsWithCollapse"
                :contracts-with-not-collapse="contractsWithNotCollapse"
                :show-more-contracts-button-label="showMoreContractsButtonLabel"
                :show-less-contracts-button-label="showLessContractsButtonLabel"
                :title="mobileHome.zoneContractsSubtitle"
            />
            <zone-marchand-parcours
                v-if="mobileHome.zoneMarchandParcoursOpen"
                :zone-marchand-parcours="mobileHome.zoneMarchandParcoursOpen"
                :title="mobileHome.zoneMarchandParcoursSubtitle"
            />
            <zone-marchand-parcours
                v-if="mobileHome.zoneMarchandParcoursMobile"
                :zone-marchand-parcours="mobileHome.zoneMarchandParcoursMobile"
                :title="mobileHome.zoneMarchandParcoursSubtitle"
            />
        </template>
        <template v-else-if="mobileHome.zoneRecoInternet">
            <zone-reco-internet :zone-reco-internet="mobileHome.zoneRecoInternet" />
        </template>
        <template v-else>
            <zone-mobiles :zone-mobiles="mobileHome.zoneMobiles" :title="mobileHome.mobilesSubtitle" />
            <div class="pt-2 pb-2 pb-md-4 bg-gray2">
                <div class="container-fluid">
                    <zones-forfaits :zone-offers="mobileHome.zoneOffers" :title="mobileHome.offersSubtitle" />
                </div>
            </div>
        </template>

        <!--/* Mobiles recommandés */-->
        <template v-if="mobileHome.hasConvergentOrMobileContract">
            <template v-if="loading">
                <skeleton-reco-mobiles-card />
            </template>
            <template v-else>
                <template v-if="displayRecoMobiles">
                    <reco-mobiles
                        :mobiles="reco.mobiles"
                        :title="reco.title"
                        shop="ORANGE"
                        :advantage-messages="mobileHome.advantageMessages"
                        :link-label="mobileHome.zoneMobiles.zoneMobilesItem[1].labelButton"
                        :link-url="mobileHome.zoneMobiles.zoneMobilesItem[0].urlButton"
                        data-pdb-zid="shop-digital_cremaillere_n1_client_zone-reco-tuile_"
                        :funding-details-dto="fundingDetailsDto"
                        @fundingDetailsClick="handleFundingDetailsClick"
                    />
                    <!-- Popin de financement-->
                    <pxf-cb4x-modal
                        v-if="selectedFundingDetailVersionPrice"
                        modal-id="funding-details-popin"
                        :display-cb4x="selectedFundingDetailVersionPrice.isCb4xAvailable"
                        :display-pxf="selectedFundingDetailVersionPrice.isPxfAvailable"
                    >
                        <template v-if="selectedFundingDetailVersionPrice.isCb4xAvailable" #cb4x-content>
                            <!-- 4xCB payant  -->
                            <paying-detail-cb4x-modal-content
                                v-if="fundingDetailsDto.cb4xPopin.withFees"
                                modal-id="funding-details-popin"
                                :oney-merchant-guid="fundingDetailsDto.cb4xPopin.oneyMerchantGuid"
                                :oney-widget-src="fundingDetailsDto.oneyWidgetSrc"
                                :counter-delay="fundingDetailsDto.counterDelay"
                                :amount="selectedFundingDetailVersionPrice.totalPriceWithPromo / 100"
                                :header-block="fundingDetailsDto.cb4xPopin.headerBlock"
                                :how-to-benefit="fundingDetailsDto.cb4xPopin.howToBenefit"
                                :cgu="fundingDetailsDto.cb4xPopin.cgu"
                                :illustration="fundingDetailsDto.cb4xPopin.imageZen"
                            />
                            <!-- 4xCB gratuit avec détail du prix  -->
                            <cb4x-modal-content
                                v-else-if="selectedFundingDetailVersionPrice.spreadingPrice4xCbWithoutFees"
                                :header-block="fundingDetailsDto.cb4xPopin.headerBlock"
                                :payment-block="fundingDetailsDto.cb4xPopin.paymentBlock"
                                :payment-simulation-block="fundingDetailsDto.cb4xPopin.paymentSimulationBlock"
                                :how-to-benefit="fundingDetailsDto.cb4xPopin.howToBenefit"
                                :faq="fundingDetailsDto.cb4xPopin.faqBlock"
                                :cgu="fundingDetailsDto.cb4xPopin.cgu"
                                :monthly-price="selectedFundingDetailVersionPrice.spreadingPrice4xCbWithoutFees.monthlyPrice"
                                :first-monthly-price="selectedFundingDetailVersionPrice.spreadingPrice4xCbWithoutFees.firstMonthlyPrice"
                                :one-shot-price="selectedFundingDetailVersionPrice.spreadingPrice4xCbWithoutFees.oneShotPrice"
                                :illustration="fundingDetailsDto.cb4xPopin.imageZen"
                            />
                        </template>
                        <!-- Payez en 12x, 24x, 36x ou 48x  -->
                        <template v-if="selectedFundingDetailVersionPrice.isPxfAvailable" #pxf-content>
                            <pxf-modal-content
                                :header-block-dto="fundingDetailsDto.pxfPopin.headerBlockDto"
                                :example-pxf-data="fundingDetailsDto.pxfPopin.examplePxfData"
                                :example-pxf-tab-subtitle="fundingDetailsDto.pxfPopin.examplePxfTabSubtitle"
                                :example-pxf-tab-title="fundingDetailsDto.pxfPopin.examplePxfTabTitle"
                                :version-pxf-data="selectedFundingDetailVersionPrice.versionPxfData"
                                :version-pxf-tab-title="fundingDetailsDto.pxfPopin.versionPxfTabTitle"
                                :pxf-legal-mentions-text="fundingDetailsDto.pxfPopin.pxfLegalMentionsText"
                                :illustration="fundingDetailsDto.pxfPopin.imageZen"
                                :financing-block="fundingDetailsDto.pxfPopin.financingBlock"
                                :cgu="fundingDetailsDto.pxfPopin.cguDto"
                                :how-to-benefit-dto="fundingDetailsDto.pxfPopin.howToBenefitDto"
                            />
                        </template>
                    </pxf-cb4x-modal>
                </template>
                <template v-else>
                    <zone-equipments
                        :equipments-band="mobileHome.equipmentsBand"
                        :title="mobileHome.equipmentsBandSubtitle"
                        :label-button="mobileHome.zoneMobiles.zoneMobilesItem[1].labelButton"
                        :url-button="mobileHome.zoneMobiles.zoneMobilesItem[0].urlButton"
                    />
                </template>
            </template>
        </template>
        <!--/* Bande Equipement */-->
        <template v-else>
            <zone-equipments
                :equipments-band="mobileHome.equipmentsBand"
                :title="mobileHome.equipmentsBandSubtitle"
                :label-button="mobileHome.zoneMobiles.zoneMobilesItem[1].labelButton"
                :url-button="mobileHome.zoneMobiles.zoneMobilesItem[0].urlButton"
            />
        </template>

        <!--/* Zone reassurance Equipements */-->
        <div v-if="mobileHome.zoneReassuranceEquipments" class="container-fluid">
            <zone-reassurance-equipments :zone-reassurance-equipments="mobileHome.zoneReassuranceEquipments" />
        </div>
        <!--/* Zone reassurance  */-->
        <div class="container-fluid">
            <zone-reassurance :zone-reassurance="mobileHome.zoneReassurance" />
        </div>
        <!--/* Mention légales */-->
        <legal-mentions-device
            :title="mobileHome.legalMentions.title"
            :pxf-legal-mentions-text="hasDeviceWithPxFPromoted ? mobileHome.legalMentions.pxfMention : null "
            :cb4x-legal-mentions-text="hasDeviceWith4xCBPromoted ? mobileHome.legalMentions.cb4xMention : null"
            :popin4x-cb="mobileHome.legalMentions.popin4xCb"
            :general-legal-mentions="mobileHome.legalMentions.generalMentions"
        />

        <div class="bg-gray2 pt-1 pb-2">
            <div class="container-fluid">
                <h3 class="lead fw-bold mb-0" v-html="mobileHome.deviceMentions.title" />
                <div class="small mb-2" v-html="mobileHome.deviceMentions.text" />
            </div>
        </div>

        <!--/* Zone Engagements */-->
        <div class="bg-dark">
            <div class="container-fluid">
                <orange-commitments :commitments="mobileHome.orangeCommitments" />
            </div>
        </div>

        <!--/* Zone Fil d'Ariane */-->
        <div class="bg-dark pt-1 pt-md-2 pb-1">
            <div class="container-fluid">
                <ob1-breadcrumb is-inverse :items="mobileHome.filAriane.items" />
            </div>
        </div>
    </div>
</template>

<script>

import OrangeCommitments from "../common/components/OrangeCommitments.vue";
import ZoneMobiles from "./ZoneMobiles.vue";
import ZonesForfaits from "./ZoneForfaits.vue";
import ZoneEquipments from "./ZoneEquipments.vue";
import ZoneMarchandParcours from "./ZoneMarchandParcours.vue";
import ZoneReassurance from "./ZoneReassurance.vue";
import ZoneReassuranceEquipments from "./ZoneReassuranceEquipments.vue";
import ZoneRecoInternet from "./ZoneRecoInternet.vue";
import RecoMobiles from "../common/selector/fragment/RecoMobiles.vue";
import SkeletonRecoMobilesCard from "../common/selector/fragment/SkeletonRecoMobilesCard.vue";
import ZoneContractsCollapse from "./ZoneContractsCollapse.vue";
import LegalMentionsDevice from "../common/components/LegalMentionDevice.vue";
import PxfModalContent from "../common/components/PxfModalContent.vue";
import Cb4xModalContent from "../common/components/Cb4xModalContent.vue";
import PayingDetailCb4xModalContent from "../common/components/PayingDetailCb4xModalContent.vue";
import PxfCb4xModal from "../common/components/PxfCb4xModal.vue";

const mobileHomeDTO = JSON.parse(document.getElementById('mobile-home').dataset.mobileHome);
export default {
    name: "MobileHome",
    components: {
        PxfCb4xModal, PayingDetailCb4xModalContent, Cb4xModalContent, PxfModalContent,
        LegalMentionsDevice,
        ZoneContractsCollapse,
        SkeletonRecoMobilesCard,
        RecoMobiles,
        ZoneRecoInternet,
        ZoneReassuranceEquipments,
        ZoneReassurance,
        ZoneMarchandParcours,
        ZoneEquipments,
        ZonesForfaits,
        ZoneMobiles,
        OrangeCommitments

    },
    data() {
        return {
            mobileHome: mobileHomeDTO,
            loading: true,
            reco: null,
            hasDeviceWith4xCBPromoted: false,
            hasDeviceWithPxFPromoted: false,
            fundingDetailsDto: mobileHomeDTO.fundingDetailsDto,
            fundingDetailsSeoId: '',
        }
    },
    computed: {
        displayRecoMobiles() {
            return !this.loading && this.reco && this.reco.mobiles.length > 0;
        },
        cid() {
            return this.mobileHome.cid
        },
        contractsWithNotCollapse() {
            let contractsSize = this.mobileHome.zoneContracts.zoneContractsItem.length - this.numberOfContractsToCollapse
            if (contractsSize > 0)
                return this.mobileHome.zoneContracts.zoneContractsItem.slice(0, this.numberOfContractsToCollapse);
            else return this.mobileHome.zoneContracts.zoneContractsItem;
        },
        contractsWithCollapse() {
            let contractsSize = this.mobileHome.zoneContracts.zoneContractsItem.length - this.numberOfContractsToCollapse
            if (contractsSize > 0)
                return this.mobileHome.zoneContracts.zoneContractsItem.slice(this.numberOfContractsToCollapse, this.mobileHome.zoneContracts.zoneContractsItem.length);
            else return [];
        },
        numberOfContractsToCollapse() {
            return this.mobileHome.zoneContracts.numberOfContractsToCollapse;
        },
        showMoreContractsButtonLabel() {
            return this.mobileHome.zoneContracts.showMoreButtonLabel
        },
        showLessContractsButtonLabel() {
            return this.mobileHome.zoneContracts.showLessButtonLabel
        },
        selectedFundingDetailVersionPrice() {
            return this.reco.mobiles.find(mobile => mobile.seoId.value === this.fundingDetailsSeoId)?.price?.price;
        }
    },
    mounted: function () {
        const swiper = new Swiper(".zone-menu-swiper-container", {
            slidesPerView: 2.5,
            spaceBetween: 15,
            centeredSlides: false,
            centeredSlidesBounds: true,
            initialSlide: 0,
        });
        //Recupérer les mobiles recommandés de l'api /mobiles/reco
        this.loading = true;
        this.fetchRecoMobiles().then(result => {
            this.reco = result
            this.hasDeviceWith4xCBPromoted = result.mobiles.some(mobile => mobile.price && mobile.price.price.paymentInfoLabel?.type =='CB4X');
            this.hasDeviceWithPxFPromoted = result.mobiles.some(mobile => mobile.price && mobile.price.price.paymentInfoLabel?.type == 'PXF');
            this.loading = false;
        }).catch((error) => {
            this.loading = false;
        });
    },
    methods: {
        numberOfRows(col) {
            return Math.trunc((this.mobileHome.zoneMenu.zoneMenuItem.length - 1) / col) + 1;
        },
        index(x, y, col) {
            return (x - 1) + (y - 1) * col;
        },
        fetchRecoMobiles() {
            let url = "/api/mobile/mobiles/reco"
            return new Promise((resolve, reject) => {
                $.ajax({
                    method: "GET",
                    data: {
                        "shop": "ORANGE",
                        "universe": "MOBILE",
                        "intention": "acquisition",
                        "cid": this.cid
                    },
                    url: url,
                    contentType: "application/json",
                    dataType: "json"
                }).done(result => {
                    resolve(result)
                }).fail(error => {
                    reject(error)
                })
            })
        },
        handleFundingDetailsClick(versionSeoId) {
            this.fundingDetailsSeoId = versionSeoId
        }
    }
}
</script>

<style lang="scss">

.font-size-48 {
    font-size: 48px;
}

.swiper-1row > div {
    overflow: hidden;
}

</style>
